var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChademo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#f1f5ff;stroke:#353841;stroke-width:1.5px;}.b{fill:#cad0e4;}.c{fill:#353841;}.d,.g{fill:#71778a;}.e,.g{stroke:none;}.f{fill:none;}.h{filter:url(#k);}.i{filter:url(#i);}.j{filter:url(#g);}.k{filter:url(#e);}.l{filter:url(#c);}.m{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 37,
    y: 27.031,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 29,
    y: 18,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 29,
    y: 40,
    width: 16,
    height: 16,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "g",
    x: 17,
    y: 27.031,
    width: 20,
    height: 20,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "h"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "h"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "i",
    x: 33,
    y: 22,
    width: 8,
    height: 8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "j"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "j"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 33,
    y: 44,
    width: 8,
    height: 8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 74,
    height: 74,
    rx: 12
  }), /*#__PURE__*/React.createElement("rect", {
    className: "f",
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-335 -577)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21,0A21,21,0,1,1,0,21,21,21,0,0,1,21,0Z",
    transform: "translate(351 593)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "matrix(1, 0, 0, 1, 335, 577)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(40 30.03)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 7 13 C 3.691590070724487 13 1 10.30840969085693 1 7 C 1 3.691590070724487 3.691590070724487 1 7 1 C 10.30840969085693 1 13 3.691590070724487 13 7 C 13 10.30840969085693 10.30840969085693 13 7 13 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 7 2 C 4.242989540100098 2 2 4.242989540100098 2 7 C 2 9.757009506225586 4.242989540100098 12 7 12 C 9.757009506225586 12 12 9.757009506225586 12 7 C 12 4.242989540100098 9.757009506225586 2 7 2 M 7 0 C 10.86598968505859 0 14 3.134010314941406 14 7 C 14 10.86598968505859 10.86598968505859 14 7 14 C 3.134010314941406 14 0 10.86598968505859 0 7 C 0 3.134010314941406 3.134010314941406 0 7 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "l",
    transform: "matrix(1, 0, 0, 1, 335, 577)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(32 21)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 5 9 C 2.794389963150024 9 1 7.205609798431396 1 5 C 1 2.794389963150024 2.794389963150024 1 5 1 C 7.205609798431396 1 9 2.794389963150024 9 5 C 9 7.205609798431396 7.205609798431396 9 5 9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 5 2 C 3.345789909362793 2 2 3.345789909362793 2 5 C 2 6.654210090637207 3.345789909362793 8 5 8 C 6.654210090637207 8 8 6.654210090637207 8 5 C 8 3.345789909362793 6.654210090637207 2 5 2 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "matrix(1, 0, 0, 1, 335, 577)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(32 43)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 5 9 C 2.794389963150024 9 1 7.205609798431396 1 5 C 1 2.794389963150024 2.794389963150024 1 5 1 C 7.205609798431396 1 9 2.794389963150024 9 5 C 9 7.205609798431396 7.205609798431396 9 5 9 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 5 2 C 3.345789909362793 2 2 3.345789909362793 2 5 C 2 6.654210090637207 3.345789909362793 8 5 8 C 6.654210090637207 8 8 6.654210090637207 8 5 C 8 3.345789909362793 6.654210090637207 2 5 2 M 5 0 C 7.761420249938965 0 10 2.238580226898193 10 5 C 10 7.761420249938965 7.761420249938965 10 5 10 C 2.238580226898193 10 0 7.761420249938965 0 5 C 0 2.238580226898193 2.238580226898193 0 5 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "matrix(1, 0, 0, 1, 335, 577)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(20 30.03)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M 7 13 C 3.691590070724487 13 1 10.30840969085693 1 7 C 1 3.691590070724487 3.691590070724487 1 7 1 C 10.30840969085693 1 13 3.691590070724487 13 7 C 13 10.30840969085693 10.30840969085693 13 7 13 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M 7 2 C 4.242989540100098 2 2 4.242989540100098 2 7 C 2 9.757009506225586 4.242989540100098 12 7 12 C 9.757009506225586 12 12 9.757009506225586 12 7 C 12 4.242989540100098 9.757009506225586 2 7 2 M 7 0 C 10.86598968505859 0 14 3.134010314941406 14 7 C 14 10.86598968505859 10.86598968505859 14 7 14 C 3.134010314941406 14 0 10.86598968505859 0 7 C 0 3.134010314941406 3.134010314941406 0 7 0 Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "matrix(1, 0, 0, 1, 335, 577)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1,0A1,1,0,1,1,0,1,1,1,0,0,1,1,0Z",
    transform: "translate(36 25)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "matrix(1, 0, 0, 1, 335, 577)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M1,0A1,1,0,1,1,0,1,1,1,0,0,1,1,0Z",
    transform: "translate(36 47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChademo);
export default __webpack_public_path__ + "static/media/chademo.3788d89ac52753ccc0f9aa41b36d00c9.svg";
export { ForwardRef as ReactComponent };